export type SendBoundVerdict = "ok" | "below_min" | "above_max" | "skip";

export function compareSendToBound(
  sendAmount: number | null | undefined,
  bound: { minAmount: number | null; maxAmount: number | null } | undefined
): SendBoundVerdict {
  if (sendAmount == null || !Number.isFinite(sendAmount) || sendAmount <= 0) {
    return "skip";
  }
  if (!bound) return "skip";
  const { minAmount, maxAmount } = bound;
  if (minAmount == null && maxAmount == null) return "skip";
  if (minAmount != null && sendAmount < minAmount) return "below_min";
  if (maxAmount != null && sendAmount > maxAmount) return "above_max";
  return "ok";
}
